/* O. FILES theme.js: mobile menu, cart, prefetch, zoom and route swaps.
   Progressive enhancement throughout; the arrival guard is inline in theme.liquid because it
   must run before first paint. */

(function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var rail = document.getElementById('nav-rail');
  if (!toggle || !rail) return;

  /* Mobile menu. Below the breakpoint, the first tap on a top-level item with children
     expands it in place.
     The tree state is snapshotted when the overlay opens and restored if it closes without
     navigating. */
  var snapshot = null;

  function remember() {
    return Array.prototype.map.call(
      rail.querySelectorAll('.rail__link--1, .rail__branch'),
      function (el) { return [el, el.classList.contains('is-open')]; }
    );
  }

  function setOpen(open, keepTree) {
    if (open && !rail.classList.contains('is-open')) snapshot = remember();
    if (!open && snapshot) {
      if (!keepTree) {
        snapshot.forEach(function (s) { s[0].classList.toggle('is-open', s[1]); });
        syncExpanded();
      }
      snapshot = null;
    }
    rail.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('menu-open', open);
  }

  toggle.addEventListener('click', function () {
    setOpen(!rail.classList.contains('is-open'));
  });

  function branchOf(a) {
    return a.parentElement.querySelector(':scope > .rail__branch');
  }

  /* One open at a time: expanding an item collapses the other open top-level item. */
  function expand(a) {
    Array.prototype.forEach.call(rail.querySelectorAll('.rail__link--1.is-open'), function (other) {
      if (other === a) return;
      other.classList.remove('is-open');
      var b = branchOf(other);
      if (b) b.classList.remove('is-open');
    });
    a.classList.add('is-open');
    branchOf(a).classList.add('is-open');
    syncExpanded();
  }

  /* Toggle items: top-level items with children and a # link (data-rail-toggle) open in
     place and never navigate.
     Desktop: opening one collapses the route state and remembers it; clicking again, the
     current page or Escape restores it.
     On a product route the rail moves to the pinned position (rail--toggled) using the swap
     layer freeze/settle. */
  var routeState = null;

  function syncExpanded() {
    Array.prototype.forEach.call(rail.querySelectorAll('[data-rail-toggle]'), function (t) {
      t.setAttribute('aria-expanded', t.classList.contains('is-open') ? 'true' : 'false');
    });
  }

  function collapse(a) {
    a.classList.remove('is-open');
    var b = branchOf(a);
    if (b) b.classList.remove('is-open');
    syncExpanded();
  }

  /* ofilesRailMove comes from the swap layer; without it the change just happens. */
  function moveRail(change) {
    if (window.ofilesRailMove) window.ofilesRailMove(change); else change();
  }

  function openToggle(a) {
    if (routeState) { expand(a); return; }
    routeState = remember();
    if (rail.classList.contains('rail--product')) {
      moveRail(function () {
        rail.classList.add('rail--toggled');
        expand(a);
      });
    } else {
      expand(a);
    }
  }

  function closeToggle() {
    if (!routeState) return;
    var saved = routeState;
    routeState = null;
    var restore = function () {
      saved.forEach(function (s) { s[0].classList.toggle('is-open', s[1]); });
      rail.classList.remove('rail--toggled');
      syncExpanded();
    };
    if (rail.classList.contains('rail--toggled')) moveRail(restore); else restore();
  }

  document.addEventListener('ofiles:swap', function () {
    routeState = null;
    syncExpanded();
  });

  /* Links and Escape close the overlay. Exception: first tap on a closed item with children
     on a phone expands it. preventDefault also stops the route swap. */
  rail.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;

    if (a.hasAttribute('data-rail-toggle')) {
      e.preventDefault();
      var overlay = rail.classList.contains('is-open');
      var opened = a.classList.contains('is-open');
      if (overlay) {
        if (opened) collapse(a); else expand(a);
      } else if (window.matchMedia('(min-width: 1024px)').matches) {
        if (opened) closeToggle(); else openToggle(a);
      }
      return;
    }

    /* With a toggle open the current page link is clickable again; clicking it restores the
       route state. */
    if (routeState && a.getAttribute('aria-current') === 'page') {
      e.preventDefault();
      closeToggle();
      return;
    }

    if (rail.classList.contains('is-open') &&
        window.matchMedia('(max-width: 1023px)').matches &&
        a.classList.contains('rail__link--1') &&
        !a.classList.contains('is-open') &&
        branchOf(a)) {
      e.preventDefault();
      expand(a);
      return;
    }

    /* A link opening in a new tab does not leave the page, so restore the tree. */
    var u = new URL(a.href, location.href);
    var leaving = a.target !== '_blank' &&
      (u.pathname !== location.pathname || u.search !== location.search);
    setOpen(false, leaving);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (rail.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    } else if (routeState) {
      closeToggle();
    }
  });

  /* Viewport grew past the breakpoint with the overlay open: drop the open state and scroll
     lock. */
  var mq = window.matchMedia('(min-width: 1024px)');
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function (e) {
    if (e.matches) setOpen(false);
    else closeToggle();   /* a desktop toggle left open must not become the
                             overlay state */
  });
})();

/* --------------------------------------------------------------------------
   Cart: quantity, remove and add-to-cart via the Section Rendering API.
   Steppers are real /cart/change links and add-to-cart is a real form POST, so everything
   works without JS.
   -------------------------------------------------------------------------- */

(function () {
  var root = function () { return document.querySelector('[data-cart-section]'); };
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function setCount(n) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) els[i].textContent = n;
  }

  function swapSection(html, sectionId) {
    var el = root();
    if (!el || !html || !html[sectionId]) return;
    var doc = new DOMParser().parseFromString(html[sectionId], 'text/html');
    var next = doc.querySelector('[data-cart-section]');
    if (!next) return;
    /* Carry the mobile bar state across the re-render. */
    var oldBar = el.querySelector('[data-bag-bar].is-shown');
    var newBar = next.querySelector('[data-bag-bar]');
    if (oldBar && newBar) newBar.classList.add('is-shown');
    el.replaceWith(next);
    bindBar();
  }

  /* Mobile checkout bar: shown while the summary CHECKOUT is below the screen. Re-bound
     after every section swap. */
  var barIO = null;
  function bindBar() {
    if (barIO) { barIO.disconnect(); barIO = null; }
    var el = root();
    if (!el || !('IntersectionObserver' in window)) return;
    var bar = el.querySelector('[data-bag-bar]');
    var real = el.querySelector('[data-bag-checkout]');
    if (!bar || !real) return;
    barIO = new IntersectionObserver(function (entries) {
      var e = entries[entries.length - 1];
      bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top > 0);
    });
    barIO.observe(real);
  }
  bindBar();

  /* Look the line up by key each time; a successful change replaces the whole section. */
  function note(key, text, isError) {
    var el = root();
    if (!el || !key) return;
    var lineEl = el.querySelector('[data-bag-key="' + key + '"]');
    var slot = lineEl && lineEl.querySelector('[data-bag-note]');
    if (!slot) return;
    slot.textContent = text;
    slot.className = 'bag__note' + (isError ? ' bag__note--error' : '');
  }

  /* --- quantity and remove --- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-cart-change]');
    if (!link) return;

    var el = root();
    if (!el) return;

    var url;
    try { url = new URL(link.getAttribute('href'), location.origin); } catch (err) { return; }
    /* Steppers use ?line=N, Shopify url_to_remove uses ?id=<key>. The AJAX API accepts both.
       id is a string; do not coerce it. */
    var quantity = url.searchParams.get('quantity');
    var line = url.searchParams.get('line');
    var id = url.searchParams.get('id');
    if (quantity === null || (line === null && id === null)) return;   // let the link do its job

    e.preventDefault();

    /* The line key survives the section swap. */
    var lineEl = link.closest('.bag__item');
    var key = (lineEl && lineEl.getAttribute('data-bag-key')) || id;
    var wanted = Number(quantity);

    var sectionId = el.getAttribute('data-cart-section');
    /* The root attribute blocks double clicks; only the line dims. */
    el.setAttribute('aria-busy', 'true');
    if (lineEl) lineEl.setAttribute('aria-busy', 'true');

    var payload = { quantity: wanted, sections: sectionId };
    if (line !== null) { payload.line = Number(line); } else { payload.id = id; }

    fetch(routeRoot + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        /* A 422 can still change the cart (e.g. capped to available stock) while returning
           no state.
           Re-render from /cart and re-read the count from /cart.js, then report the real
           quantity. */
        if (!res.ok) {
          var refusal = res.d.description || res.d.message || 'Could not update this line';
          return Promise.all([
            fetch(routeRoot + 'cart?sections=' + encodeURIComponent(sectionId)).then(function (r) { return r.json(); }),
            fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); })
          ]).then(function (both) {
            var sections = both[0];
            var cart = both[1];
            swapSection(sections, sectionId);
            setCount(cart.item_count);

            var held = null;
            for (var j = 0; j < cart.items.length; j++) {
              if (cart.items[j].key === key) { held = cart.items[j].quantity; break; }
            }
            note(key, (held !== null && wanted > held) ? ('Only ' + held + ' available') : refusal, true);
          });
        }

        swapSection(res.d.sections, sectionId);
        setCount(res.d.item_count);

        /* A 200 can still cap the line, so read the quantity back. */
        if (!key || wanted <= 0 || !res.d.items) return;
        var got = null;
        for (var i = 0; i < res.d.items.length; i++) {
          if (res.d.items[i].key === key) { got = res.d.items[i].quantity; break; }
        }
        if (got !== null && got !== wanted) {
          note(key, 'Only ' + got + ' available', true);
        }
      })
      .catch(function () { location.href = link.href; })
      .then(function () {
        var r2 = root();
        if (r2) r2.removeAttribute('aria-busy');
        var l2 = r2 && key && r2.querySelector('[data-bag-key="' + key + '"]');
        if (l2) l2.removeAttribute('aria-busy');
      });
  });

  /* --- add to cart --- posts in place and updates the bag count; the button confirms briefly. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;

    var button = form.querySelector('.panel__atc');
    if (!button || button.disabled) return;

    e.preventDefault();
    var original = button.textContent;
    button.disabled = true;

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || 'Could not add to bag');
        button.textContent = 'Added to bag';
        return fetch(routeRoot + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function (err) { button.textContent = err.message || 'Try again'; })
      .then(function () {
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1600);
      });
  });
})();

/* --------------------------------------------------------------------------
   Prefetch on hover, for internal links the route swap does not handle (/cart, search, theme
   editor).
   The swap layer prefetches its own routes into memory (see PAGE CHANGE).
   -------------------------------------------------------------------------- */

(function () {
  if (!('connection' in navigator) || !navigator.connection.saveData) {
    var seen = {};

    function prefetch(href) {
      if (!href || seen[href]) return;
      seen[href] = true;
      var link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    }

    function candidate(e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a) return;
      if (a.origin !== location.origin) return;          // off-site
      if (a.pathname === location.pathname) return;      // already here
      if (a.hasAttribute('data-cart-change')) return;    // these are actions, not pages
      if (a.getAttribute('href').charAt(0) === '#') return;
      if (window.ofilesSwapOwns && window.ofilesSwapOwns(a)) return;   // the swap layer fetches these itself
      prefetch(a.href);
    }

    document.addEventListener('mouseover', candidate, { passive: true });
    document.addEventListener('touchstart', candidate, { passive: true });
  }
})();

/* --------------------------------------------------------------------------
   Image zoom: opens over a blurred wash of the ground colour.
   -------------------------------------------------------------------------- */

(function () {
  /* Product photography opens large. Mouse: fills the screen width and pans with the cursor.
     Touch: opens at 2x, centred on the tap, drag to pan.
     A 3000px file (data-zoom) swaps in once loaded. The size chart keeps fit-to-screen.
     Click or Escape closes.
     Pan uses translate, not transform, because the showup animation fills transform. */
  var overlay = null;
  var big = null;
  var raf = 0;
  var target = 0;
  var current = 0;
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');

  function close() {
    if (!overlay) return;
    cancelAnimationFrame(raf);
    raf = 0;
    document.removeEventListener('mousemove', follow);
    overlay.remove();
    overlay = null;
    big = null;
    document.documentElement.classList.remove('zoom-open');
  }

  function travel() {
    return Math.max(0, big.offsetHeight - overlay.clientHeight);
  }

  function follow(e) {
    target = Math.min(1, Math.max(0, e.clientY / window.innerHeight));
    if (!raf) raf = requestAnimationFrame(step);
  }

  function step() {
    raf = 0;
    if (!overlay) return;
    var gap = target - current;
    current = (still.matches || Math.abs(gap) < 0.001) ? target : current + gap * 0.16;
    big.style.translate = '0 ' + (-current * travel()) + 'px';
    if (current !== target) raf = requestAnimationFrame(step);
  }

  document.addEventListener('click', function (e) {
    if (overlay) { close(); return; }

    var img = e.target.closest && e.target.closest('.pdp__slide img, img.panel__chart');
    if (!img) return;

    e.preventDefault();
    var slide = img.closest('.pdp__slide');
    var mode = !slide ? '' : (mouse.matches ? ' zoom--follow' : ' zoom--drag');

    overlay = document.createElement('div');
    overlay.className = 'zoom' + mode;
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', img.getAttribute('alt') || 'Product image');
    overlay.tabIndex = -1;

    big = document.createElement('img');
    big.src = img.currentSrc || img.src;
    big.alt = img.getAttribute('alt') || '';
    if (img.naturalWidth) big.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
    overlay.appendChild(big);

    document.body.appendChild(overlay);
    document.documentElement.classList.add('zoom-open');
    overlay.focus();

    if (!slide) return;

    var hi = slide.getAttribute('data-zoom');
    if (hi) {
      var pre = new Image();
      var mine = big;
      pre.onload = function () { if (big === mine) mine.src = hi; };
      pre.src = hi;
    }

    var r = img.getBoundingClientRect();
    var fx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    var fy = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));

    if (mode === ' zoom--follow') {
      target = current = Math.min(1, Math.max(0, e.clientY / window.innerHeight));
      big.style.translate = '0 ' + (-current * travel()) + 'px';
      document.addEventListener('mousemove', follow, { passive: true });
    } else {
      overlay.scrollLeft = fx * (overlay.scrollWidth - overlay.clientWidth);
      overlay.scrollTop = fy * (overlay.scrollHeight - overlay.clientHeight);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* --------------------------------------------------------------------------
   Image arrival: images fade in once decoded (data-loaded). Cached images get the flag at
   once.
   A MutationObserver covers lazy images and anything the cart re-renders.
   -------------------------------------------------------------------------- */

(function () {
  /* Gallery images and videos use the same flag. */
  var SEL = '.card__media img, .pdp__slide img, ' +
            '.hero__frame img, .hero__frame video, ' +
            '.gallery__frame img, .gallery__frame video, .bag__item img, ' +
            '.feature__frame img, .feature__frame video, ' +
            '.slider__frame img';   /* homepage slider */

  function mark(img) {
    if (img.hasAttribute('data-loaded')) return;
    img.setAttribute('data-loaded', '');
  }

  function watch(img) {
    if (img.dataset.arrivalBound) return;
    img.dataset.arrivalBound = '1';

    /* Video: loadeddata (or readyState >= 2) means the first frame is paintable. Errors must
       not stay hidden. */
    if (img.tagName === 'VIDEO') {
      if (img.readyState >= 2) { mark(img); return; }
      img.addEventListener('loadeddata', function () { mark(img); }, { once: true });
      img.addEventListener('error', function () { mark(img); }, { once: true });
      return;
    }

    /* decode() resolves when the bitmap is ready to paint; fall back to load/error. */
    if (img.complete && img.naturalWidth > 0) {
      mark(img);
      return;
    }
    img.addEventListener('load', function () {
      if (typeof img.decode === 'function') {
        img.decode().then(function () { mark(img); }, function () { mark(img); });
      } else {
        mark(img);
      }
    }, { once: true });

    /* A broken image must not stay invisible. */
    img.addEventListener('error', function () { mark(img); }, { once: true });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(SEL), watch);
    if (scope.matches && scope.matches(SEL)) watch(scope);
  }

  scan(document);

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* --------------------------------------------------------------------------
   Client-side navigation: internal links fetch the next page and replace only <main> and the
   rail state, so the rail can animate.
   History and back/forward work as normal; any failure falls back to a full navigation.
   Timing lives in PAGE CHANGE below.
   -------------------------------------------------------------------------- */

(function () {
  if (!window.history || !window.history.pushState || !window.DOMParser) return;
  if (!window.fetch || !document.querySelector('main#main')) return;

  /* Off in the theme editor: it tracks templates by watching the preview navigate. */
  if (window.Shopify && window.Shopify.designMode) return;

  /* Routes handled here. /cart, /account, /checkout, search and off-site links are left to
     the browser. */
  var SWAPPABLE = /^\/$|^\/(collections|products|pages|blogs)(\/|$)/;

  var parser = new DOMParser();
  var inflight = null;   /* AbortController for the request in flight */
  var token = 0;         /* guards against a slow response landing after a newer one */

  /* Current path + query. A history move that keeps both is an in-page anchor move; nothing
     to fetch. */
  var shown = location.pathname + location.search;

  function samePage(url) {
    return url.pathname === location.pathname && url.search === location.search;
  }

  function target(a, e) {
    if (e.defaultPrevented) return null;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return null;
    if (!a.href) return null;
    if (a.origin !== location.origin) return null;
    if (a.hasAttribute('download')) return null;
    if (a.hasAttribute('data-no-swap')) return null;
    if (a.hasAttribute('data-cart-change')) return null;   /* these are actions, not pages */
    if (a.target && a.target !== '_self') return null;

    var url = new URL(a.href);
    if (url.hash && samePage(url)) return null;            /* in-page anchor, e.g. #gallery */
    if (!SWAPPABLE.test(url.pathname)) return null;
    return url;
  }

  function hardNavigate(url) {
    document.documentElement.classList.remove('is-navigating');
    window.location.href = url.href;
  }

  /* ------------------------------------------------------------------------
     Rail vertical move. Menu routes share a pinned top edge; only a product route re-centres
     (--rail-shift: -50%).
     freeze() pins height and transform in px while the old branch collapses; settle()
     releases them, reads the real target and animates once.
     --------------------------------------------------------------------- */
  var railMove = { timer: 0 };

  function cssMs(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    if (!v) return fallback;
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return v.indexOf('ms') > -1 ? n : n * 1000;
  }

  /* Current translateY in px from the computed matrix. Mobile sets transform: none (reads as
     0). */
  function railShift(rail) {
    var m = getComputedStyle(rail).transform;
    if (!m || m === 'none') return 0;
    var parts = m.slice(m.indexOf('(') + 1, -1).split(',');
    var v = parseFloat(parts[m.indexOf('matrix3d') === 0 ? 13 : 5]);
    return isNaN(v) ? 0 : v;
  }

  function railRelease(rail) {
    rail.style.transition = '';
    rail.style.transform = '';
    rail.style.height = '';
    rail.style.overflow = '';
  }

  function railFreeze(rail) {
    if (railMove.timer) { clearTimeout(railMove.timer); railMove.timer = 0; }
    var shift = railShift(rail);
    rail.style.transition = 'none';
    rail.style.transform = 'translateY(' + shift + 'px)';
    rail.style.height = rail.getBoundingClientRect().height + 'px';
    rail.style.overflow = 'hidden';
    return shift;
  }

  function railSettle(rail, from) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
      railRelease(rail);
      return;
    }
    var exit = cssMs('--speed-state', 200);
    var move = cssMs('--speed-bar', 300);
    var ease = getComputedStyle(document.documentElement).getPropertyValue('--ease').trim() || 'ease';

    railMove.timer = setTimeout(function () {
      /* Collapse finished: hand the rail back to the stylesheet and read its target. */
      rail.style.transition = 'none';
      rail.style.height = 'auto';
      rail.style.overflow = '';
      rail.style.transform = '';
      var to = railShift(rail);

      if (Math.abs(to - from) < 1) { railRelease(rail); return; }

      rail.style.transform = 'translateY(' + from + 'px)';
      void rail.offsetHeight;                      /* commit the start value */
      rail.style.transition = 'transform ' + move + 'ms ' + ease;
      rail.style.transform = 'translateY(' + to + 'px)';

      railMove.timer = setTimeout(function () { railRelease(rail); }, move + 60);
    }, exit);
  }

  /* Freeze / change / settle for a class change that moves the rail (toggle items). */
  window.ofilesRailMove = function (change) {
    var rail = document.getElementById('nav-rail');
    if (!rail) { change(); return; }
    var from = railFreeze(rail);
    change();
    railSettle(rail, from);
  };

  /* Returns false if the two rails are not the same tree; the caller replaces the markup
     instead. */
  function patchRail(oldRail, newRail) {
    var oldLinks = oldRail.querySelectorAll('.rail__link');
    var newLinks = newRail.querySelectorAll('.rail__link');
    if (!oldLinks.length || oldLinks.length !== newLinks.length) return false;

    var i;
    for (i = 0; i < oldLinks.length; i++) {
      if (oldLinks[i].getAttribute('href') !== newLinks[i].getAttribute('href')) return false;
    }

    var oldBranches = oldRail.querySelectorAll('.rail__branch');
    var newBranches = newRail.querySelectorAll('.rail__branch');
    if (oldBranches.length !== newBranches.length) return false;

    /* State only: class, the --row/--i custom properties, and aria-current. */
    for (i = 0; i < oldLinks.length; i++) {
      oldLinks[i].className = newLinks[i].className;
      oldLinks[i].setAttribute('style', newLinks[i].getAttribute('style') || '');
      if (newLinks[i].hasAttribute('aria-current')) {
        oldLinks[i].setAttribute('aria-current', 'page');
      } else {
        oldLinks[i].removeAttribute('aria-current');
      }
    }
    for (i = 0; i < oldBranches.length; i++) {
      oldBranches[i].className = newBranches[i].className;
    }

    /* The product panel is moved rather than patched: remove and re-insert under its
       category. */
    Array.prototype.forEach.call(oldRail.querySelectorAll('.rail__panel'), function (el) {
      el.parentNode.removeChild(el);
    });

    Array.prototype.forEach.call(newRail.querySelectorAll('.rail__panel'), function (panel) {
      var owner = panel.parentNode ? panel.parentNode.querySelector('.rail__link') : null;
      var copy = panel.cloneNode(true);
      if (owner) {
        var match = oldRail.querySelector('.rail__link[href="' + owner.getAttribute('href') + '"]');
        if (match) { match.parentNode.insertBefore(copy, match.nextSibling); return; }
      }
      /* The fallback panel, under no category. */
      var grid = oldRail.querySelector('.rail__grid');
      if (grid) {
        var li = document.createElement('li');
        li.appendChild(copy);
        grid.appendChild(li);
      }
    });

    oldRail.className = newRail.className;
    return true;
  }

  /* Archive on desktop: swap only the entry so the index keeps its scroll position. Returns
     false if the indexes differ. */
  function swapArchive(oldMain, newMain) {
    if (window.matchMedia && !matchMedia('(min-width: 1024px)').matches) return false;
    var oldArc = oldMain.querySelector('[data-archive]');
    var newArc = newMain.querySelector('[data-archive]');
    if (!oldArc || !newArc) return false;
    var oldEntry = oldArc.querySelector('[data-archive-entry]');
    var newEntry = newArc.querySelector('[data-archive-entry]');
    if (!oldEntry || !newEntry) return false;

    var oldRows = oldArc.querySelectorAll('.archive__row');
    var newRows = newArc.querySelectorAll('.archive__row');
    if (!oldRows.length || oldRows.length !== newRows.length) return false;
    var i;
    for (i = 0; i < oldRows.length; i++) {
      if (oldRows[i].getAttribute('href') !== newRows[i].getAttribute('href')) return false;
    }

    oldArc.className = newArc.className;
    for (i = 0; i < oldRows.length; i++) {
      var cur = newRows[i].getAttribute('aria-current');
      if (cur) { oldRows[i].setAttribute('aria-current', cur); }
      else { oldRows[i].removeAttribute('aria-current'); }
    }

    oldEntry.innerHTML = newEntry.innerHTML;
    oldEntry.classList.remove('is-entering');
    void oldEntry.offsetWidth;                     /* restart the arrival */
    oldEntry.classList.add('is-entering');

    /* Keep the open file row in view inside the sticky index. */
    var idx = oldArc.querySelector('.archive__index');
    var row = idx && idx.querySelector('.archive__row[aria-current]');
    if (row) {
      var top = row.offsetTop;
      var bottom = top + row.offsetHeight;
      if (top < idx.scrollTop) idx.scrollTop = top;
      else if (bottom > idx.scrollTop + idx.clientHeight) idx.scrollTop = bottom - idx.clientHeight;
    }
    return true;
  }

  /* Rail half of a route change. Runs at the click when the page is already fetched;
     resolves after --speed-state. */
  function railPhase(doc) {
    var oldRail = document.getElementById('nav-rail');
    var newRail = doc.getElementById('nav-rail');
    if (!oldRail) return Promise.resolve();

    /* The rail is patched, not replaced, so the CSS collapse/expand has live elements to
       animate. */
    var railFrom = railFreeze(oldRail);
    if (newRail && !patchRail(oldRail, newRail)) {
      oldRail.innerHTML = newRail.innerHTML;
      /* The fallback also copies the rail classes (rail--gallery, rail--product,
         rail--line). */
      oldRail.className = newRail.className;
    }
    railSettle(oldRail, railFrom);

    if (reduceMotion && reduceMotion.matches) return Promise.resolve();
    return wait(cssMs('--speed-state', 200));
  }

  /* True when the desktop archive kept its index and only swapped the entry. */
  function apply(doc, url, opts) {
    var oldMain = document.querySelector('main#main');
    var newMain = doc.querySelector('main#main');

    /* Not one of our pages: hand it back to the browser. */
    if (!oldMain || !newMain) { hardNavigate(url); return false; }

    /* Remember where this entry was scrolled to before leaving it. */
    if (opts.push) {
      history.replaceState({ ofiles: true, scroll: window.scrollY }, '');
      history.pushState({ ofiles: true, scroll: 0 }, '', url.href);
    }
    shown = url.pathname + url.search;

    document.title = doc.title;
    document.body.className = doc.body.className;

    /* A swap is not a new visit: skip the arrival. */
    document.documentElement.classList.add('no-intro');

    var archived = swapArchive(oldMain, newMain);
    if (!archived) oldMain.innerHTML = newMain.innerHTML;

    /* Unless PAGE CHANGE already did it at the click. */
    if (!opts.railDone) railPhase(doc);

    window.scrollTo(0, opts.scroll || 0);

    /* Move focus to the new content for keyboard users. */
    oldMain.setAttribute('tabindex', '-1');
    oldMain.focus({ preventScroll: true });

    document.documentElement.classList.remove('is-navigating');

    /* Anything that re-reads the DOM listens for this event (images re-register via the
       MutationObserver).
       Shopify analytics counts one pageview per document load, so swapped routes are not
       counted. */
    document.dispatchEvent(new CustomEvent('ofiles:swap', {
      detail: { url: url.href, push: !!opts.push }
    }));
    return archived;
  }

  /* Archive on a phone: into a file the list slides left and the file comes in from the
     right; back to the list is the reverse.
     Browser back is a plain cross-fade (iOS already animates swipe-back).
     The outgoing half starts at the click so it covers the fetch. Reduced motion: short fade
     only. */
  var phone = window.matchMedia ? matchMedia('(max-width: 1023px)') : null;
  var reduceMotion = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;

  function archiveMotion(url, opts) {
    var main = document.querySelector('main#main');
    if (!main || typeof main.animate !== 'function') return null;
    if (!phone || !phone.matches) return null;
    if (!/^\/blogs\//.test(location.pathname) || !/^\/blogs\//.test(url.pathname)) return null;

    var depth = function (p) { return p.replace(/\/+$/, '').split('/').length; };
    var dir = depth(url.pathname) >= depth(location.pathname) ? 1 : -1;   /* 1 = into a file */
    var slide = opts.push && !(reduceMotion && reduceMotion.matches);
    var ease = getComputedStyle(document.documentElement).getPropertyValue('--ease').trim() || 'ease';
    var outMs = cssMs('--speed-state', 200);
    var inMs = cssMs('--speed', 500);

    var outAnim = main.animate(
      slide
        ? [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(' + (-16 * dir) + 'px)' }]
        : [{ opacity: 1 }, { opacity: 0 }],
      { duration: outMs, easing: ease, fill: 'forwards' }
    );

    return {
      out: outAnim.finished.catch(function () {}),
      enter: function () {
        outAnim.cancel();
        main.animate(
          slide
            ? [{ opacity: 0, transform: 'translateX(' + (24 * dir) + 'px)' }, { opacity: 1, transform: 'none' }]
            : [{ opacity: 0 }, { opacity: 1 }],
          { duration: slide ? inMs : outMs, easing: ease }
        );
      },
      abort: function () { outAnim.cancel(); }
    };
  }

  /* ------------------------------------------------------------------------
     PAGE CHANGE
     Fetch ahead: hover for INTENT_MS, touch or mousedown fetches the page into memory (kept
     CACHE_MS).
     Warm images: first-screen images start downloading and are marked eager in the fetched
     copy.
     Fade: <main> fades out over --speed-state while the desktop rail collapses; the swap
     waits for the fade, the collapse and the images (capped at IMAGE_WAIT).
     The new content arrives on showup. Not on the phone rail (an overlay); the archive keeps
     its own motion.
     --------------------------------------------------------------------- */
  var INTENT_MS = 100;      /* a pointer passing over a link is not interest */
  var CACHE_MS = 30000;     /* a hovered page is good for this long */
  var IMAGE_WAIT = 250;     /* longest images may hold the swap, counted from the click */

  var pages = {};           /* origin + path + query -> { t, doc: Promise<Document>, imgs: Promise } */
  var desktop = window.matchMedia ? matchMedia('(min-width: 1024px)') : null;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var motionNow = null;     /* the fade in progress, so a newer click can take over from it */

  function noop() {}

  function wait(ms) {
    return new Promise(function (done) { setTimeout(done, ms); });
  }

  function keyOf(url) {
    return url.origin + url.pathname + url.search;
  }

  function request(url, signal) {
    return fetch(url.href, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'ofiles-swap' },
      signal: signal
    })
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        if ((res.headers.get('content-type') || '').indexOf('text/html') === -1) {
          throw new Error('not html');
        }
        /* A redirect: let the browser handle it. */
        if (res.redirected && new URL(res.url).pathname !== url.pathname) {
          throw new Error('redirected');
        }
        return res.text();
      })
      .then(function (html) {
        return parser.parseFromString(html, 'text/html');
      });
  }

  /* First-screen images: two rows of cards, the first product slide, the first few frames
     otherwise. Images are the slow part, so they start on hover. */
  var WARM_SEL = '.card__media img, .pdp__slide img, .hero__frame img, ' +
                 '.slider__frame img, .feature__frame img, .gallery__frame img';
  var WARM_MAX = 6;
  var WARM_PDP = 1;

  function warm(doc) {
    var main = doc && doc.querySelector('main#main');
    if (!main || saveData) return Promise.resolve();

    var found = main.querySelectorAll(WARM_SEL);
    var jobs = [];
    var slides = 0;
    for (var i = 0; i < found.length && jobs.length < WARM_MAX; i++) {
      var src = found[i];
      if (src.classList.contains('card__img--alt')) continue;        /* the hover image */
      if (src.closest('.pdp__slide') && ++slides > WARM_PDP) continue;

      /* Set sizes before srcset before src, or the browser fetches twice. */
      var img = new Image();
      if (src.getAttribute('sizes')) img.sizes = src.getAttribute('sizes');
      if (src.getAttribute('srcset')) img.srcset = src.getAttribute('srcset');
      img.src = src.getAttribute('src') || '';
      src.setAttribute('loading', 'eager');

      jobs.push(typeof img.decode === 'function'
        ? img.decode().then(noop, noop)
        : new Promise(function (done) { img.onload = img.onerror = done; }));
    }
    return Promise.all(jobs);
  }

  function fresh(url) {
    var hit = pages[keyOf(url)];
    return hit && Date.now() - hit.t < CACHE_MS ? hit : null;
  }

  /* No image warming on touch: a finger on a card is often the start of a scroll. */
  function prefetch(url, images) {
    if (saveData) return;
    var entry = fresh(url);
    if (!entry) {
      var key = keyOf(url);
      entry = { t: Date.now() };
      entry.doc = request(url);
      entry.doc.catch(function () { if (pages[key] === entry) delete pages[key]; });
      pages[key] = entry;
    }
    if (images && !entry.imgs) entry.imgs = entry.doc.then(warm, noop);
  }

  /* Fade from the current opacity so a second click does not flash. */
  function pageMotion(url) {
    var main = document.querySelector('main#main');
    if (!main || typeof main.animate !== 'function') return null;
    if (reduceMotion && reduceMotion.matches) return null;

    var node = main;
    if (desktop && desktop.matches && /^\/blogs\//.test(url.pathname)) {
      node = main.querySelector('[data-archive] [data-archive-entry]') || main;
    }

    var from = parseFloat(getComputedStyle(node).opacity);
    if (isNaN(from)) from = 1;
    if (motionNow) motionNow.abort();

    var ease = getComputedStyle(document.documentElement).getPropertyValue('--ease').trim() || 'ease';
    var outMs = cssMs('--speed-state', 200);
    var inMs = cssMs('--speed', 500);

    var outAnim = node.animate(
      [{ opacity: from }, { opacity: 0 }],
      { duration: Math.max(1, outMs * from), easing: ease, fill: 'forwards' }
    );

    return {
      out: outAnim.finished.catch(noop),
      enter: function (archived) {
        outAnim.cancel();
        /* The archive entry arrives on its own is-entering. */
        if (archived && node !== main) return;
        main.animate(
          [{ opacity: 0, transform: 'translateY(0.8rem)' }, { opacity: 1, transform: 'none' }],
          { duration: inMs, easing: ease }
        );
      },
      abort: function () { outAnim.cancel(); }
    };
  }

  function go(url, opts) {
    var mine = ++token;
    var clicked = Date.now();
    if (inflight) { inflight.abort(); inflight = null; }

    document.documentElement.classList.add('is-navigating');

    var motion = archiveMotion(url, opts) || pageMotion(url);
    if (motion !== motionNow && motionNow) motionNow.abort();
    motionNow = motion;

    var entry = fresh(url);
    if (!entry) {
      inflight = window.AbortController ? new AbortController() : null;
      entry = { doc: request(url, inflight ? inflight.signal : undefined) };
    }
    if (!entry.imgs) entry.imgs = entry.doc.then(warm, noop);

    entry.doc
      .then(function (doc) {
        if (mine !== token) return;   /* a newer click already won */
        if (!doc.querySelector('main#main')) throw new Error('not ours');

        /* Desktop: start the rail collapse now. If the page arrived late, content and rail
           overlap rather than waiting. */
        var railReady = null;
        if (desktop && desktop.matches) {
          var collapse = railPhase(doc);
          if (Date.now() - clicked < 60) railReady = collapse;
          opts.railDone = true;
        }

        /* No fade (reduced motion): no wait. */
        var left = IMAGE_WAIT - (Date.now() - clicked);
        var images = motion && left > 0 ? Promise.race([entry.imgs, wait(left)]) : null;
        return Promise.all([motion ? motion.out : null, railReady, images]).then(function () {
          if (mine !== token) return;
          var archived = apply(doc, url, opts);
          if (motion) motion.enter(archived);
          if (motionNow === motion) motionNow = null;
        });
      })
      .catch(function (err) {
        if (mine !== token) return;
        if (motion) motion.abort();
        if (err && err.name === 'AbortError') return;
        hardNavigate(url);
      });
  }

  /* Fetch ahead the same links a click would swap. */
  function swappable(a) {
    if (!a || !a.href || a.origin !== location.origin) return null;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-swap')) return null;
    if (a.hasAttribute('data-cart-change')) return null;
    if (a.target && a.target !== '_self') return null;
    var url = new URL(a.href);
    if (samePage(url)) return null;
    if (!SWAPPABLE.test(url.pathname)) return null;
    return url;
  }

  /* Asked by the prefetch block before it adds a <link>. */
  window.ofilesSwapOwns = function (a) { return !!swappable(a); };

  var hovered = null;
  var hoverTimer = 0;

  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (a === hovered) return;
    clearTimeout(hoverTimer);
    hovered = a;
    var url = swappable(a);
    if (url) hoverTimer = setTimeout(function () { prefetch(url, true); }, INTENT_MS);
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    if (!hovered || (e.relatedTarget && hovered.contains(e.relatedTarget))) return;
    clearTimeout(hoverTimer);
    hovered = null;
  }, { passive: true });

  /* A press is a decision: no intent delay. */
  function pressed(e) {
    var url = swappable(e.target.closest && e.target.closest('a[href]'));
    if (url) prefetch(url, e.type === 'mousedown');
  }
  document.addEventListener('mousedown', pressed, { passive: true });
  document.addEventListener('touchstart', pressed, { passive: true });

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var url = target(a, e);
    if (!url) return;

    e.preventDefault();
    if (samePage(url)) return;    /* the page you are on is not a destination */
    go(url, { push: true, scroll: 0 });
  });

  /* Back and forward. Scroll position is stored in the history entry. */
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  history.replaceState({ ofiles: true, scroll: window.scrollY }, '');

  window.addEventListener('popstate', function (e) {
    var url = new URL(location.href);
    if (url.pathname + url.search === shown) {
      var id = url.hash.slice(1);
      try { id = decodeURIComponent(id); } catch (err) {}
      var el = id && document.getElementById(id);
      if (el) el.scrollIntoView({ block: 'start' });
      else window.scrollTo(0, (e.state && e.state.scroll) || 0);
      return;
    }
    if (!SWAPPABLE.test(url.pathname)) { hardNavigate(url); return; }
    go(url, { push: false, scroll: (e.state && e.state.scroll) || 0 });
  });
})();

/* --------------------------------------------------------------------------
   Moodboard: drift in, drag about (gallery section, Moodboard layout).
   Arrival: each frame gets .is-in once on entering the viewport.
   Drag (mouse only): a critically damped spring (mass 1, tension 100, friction 20); last
   picked up sits on top. Under 3px of travel is a click.
   Off in the theme editor; no spring under reduced motion. Re-runs after a swap or an editor
   re-render.
   -------------------------------------------------------------------------- */

(function () {
  var design = !!(window.Shopify && window.Shopify.designMode);
  var mouse = window.matchMedia('(min-width: 1024px) and (hover: hover) and (pointer: fine)');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)');
  var TENSION = 100, FRICTION = 20, STEP = 1 / 240;
  var topZ = 1;

  function reveal(board) {
    if (design || !('IntersectionObserver' in window)) {
      board.setAttribute('data-static', '');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0 });
    board.querySelectorAll('.gallery__item').forEach(function (item) {
      io.observe(item);
    });
    board.setAttribute('data-reveal', '');
  }

  function paint(item, s) {
    item.style.transform = 'translate3d(' + s.x.toFixed(2) + 'px,' + s.y.toFixed(2) + 'px,0)';
  }

  function run(item, s) {
    if (still.matches) { s.x = s.tx; s.y = s.ty; paint(item, s); return; }
    if (s.raf) return;
    var last = performance.now();
    function frame(now) {
      var dt = Math.min((now - last) / 1000, 1 / 30);
      last = now;
      for (var t = 0; t < dt; t += STEP) {
        var h = Math.min(STEP, dt - t);
        s.vx += (TENSION * (s.tx - s.x) - FRICTION * s.vx) * h;
        s.vy += (TENSION * (s.ty - s.y) - FRICTION * s.vy) * h;
        s.x += s.vx * h;
        s.y += s.vy * h;
      }
      var resting = Math.abs(s.tx - s.x) < 0.1 && Math.abs(s.ty - s.y) < 0.1 &&
                    Math.abs(s.vx) < 0.1 && Math.abs(s.vy) < 0.1;
      if (resting) { s.x = s.tx; s.y = s.ty; s.vx = s.vy = 0; }
      paint(item, s);
      s.raf = resting ? 0 : requestAnimationFrame(frame);
    }
    s.raf = requestAnimationFrame(frame);
  }

  function drag(board) {
    if (design) return;
    board.addEventListener('pointerdown', function (e) {
      if (!mouse.matches || e.button !== 0) return;
      var item = e.target.closest('.gallery__item');
      if (!item || !board.contains(item)) return;
      if (e.target.closest('video[controls]')) return;

      var s = item._drift || (item._drift = { x: 0, y: 0, vx: 0, vy: 0, tx: 0, ty: 0, raf: 0 });
      var startX = e.clientX, startY = e.clientY, baseX = s.tx, baseY = s.ty;
      var moved = false;

      e.preventDefault();
      item.setPointerCapture(e.pointerId);

      function move(ev) {
        var dx = ev.clientX - startX, dy = ev.clientY - startY;
        if (!moved) {
          if (Math.abs(dx) + Math.abs(dy) < 3) return;
          moved = true;
          item.style.zIndex = ++topZ;
          item.classList.add('is-dragging');
        }
        s.tx = baseX + dx;
        s.ty = baseY + dy;
        run(item, s);
      }

      function end() {
        item.classList.remove('is-dragging');
        item.removeEventListener('pointermove', move);
        item.removeEventListener('pointerup', end);
        item.removeEventListener('pointercancel', end);
      }

      item.addEventListener('pointermove', move);
      item.addEventListener('pointerup', end);
      item.addEventListener('pointercancel', end);
    });
  }

  function init() {
    document.querySelectorAll('[data-moodboard]').forEach(function (board) {
      if (board.dataset.moodboardBound) return;
      board.dataset.moodboardBound = '1';
      reveal(board);
      drag(board);
    });
  }

  init();
  document.addEventListener('ofiles:swap', init);
  document.addEventListener('shopify:section:load', init);
})();

/* --------------------------------------------------------------------------
   ACCORDIONS: animate <details> open and shut with the Web Animations API, timed from
   --speed-bar and --ease.
   Close adds is-closing (marker and margins ease with the box), then removes open.
   Mid-animation clicks reverse.
   One document listener. Without WAAPI or with reduced motion, native <details>.
   -------------------------------------------------------------------------- */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function token(name, fallback) {
    var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  }

  function ms(v) {
    return /ms$/.test(v) ? parseFloat(v) : parseFloat(v) * 1000;
  }

  /* Animate one <details> open or shut. `closing` is decided by the caller. */
  function run(details, closing) {
    var summary = details.querySelector(':scope > summary');
    var duration = ms(token('--speed-bar', '0.3s'));
    var easing = token('--ease', 'ease');
    var body = details.querySelector(':scope > :not(summary)');

    /* Measure before cancelling so a reversal starts from the on-screen size. */
    var from = details.getBoundingClientRect().height;

    if (details._accAnim) details._accAnim.cancel();
    if (details._accFade) details._accFade.cancel();
    details._accAnim = details._accFade = null;

    var to;
    if (closing) {
      details.classList.add('is-closing');
      to = summary.getBoundingClientRect().height;
    } else {
      details.classList.remove('is-closing');
      details.open = true;
      to = details.getBoundingClientRect().height;
    }

    details.style.overflow = 'hidden';
    details._accOpening = !closing;

    var anim = details.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: duration, easing: easing, fill: 'forwards' }
    );
    details._accAnim = anim;

    if (closing && body) {
      details._accFade = body.animate(
        [{ opacity: 1 }, { opacity: 0 }],
        { duration: duration * 0.6, easing: easing, fill: 'forwards' }
      );
    }

    anim.onfinish = function () {
      if (details._accAnim !== anim) return;
      if (closing) {
        details.open = false;
        details.classList.remove('is-closing');
      }
      details.style.overflow = '';
      anim.cancel();
      if (details._accFade) details._accFade.cancel();
      details._accAnim = details._accFade = null;
    };
  }

  /* Open (or opening) right now, counting an animation in flight. */
  function isOpen(d) { return d._accAnim ? d._accOpening : d.open; }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest('.panel__acc > summary');
    if (!summary || reduce.matches || typeof summary.animate !== 'function') return;

    var details = summary.parentElement;
    e.preventDefault();

    /* One open at a time: the shared name (native exclusive accordion) is moved to
       data-acc-name so the other closes on the same motion. Done lazily on first click. */
    var group = details.getAttribute('name') || details.getAttribute('data-acc-name');
    var peers = [];
    if (group) {
      var scope = details.closest('.panel') || document;
      var all = scope.querySelectorAll('details.panel__acc');
      for (var i = 0; i < all.length; i++) {
        var d = all[i];
        var g = d.getAttribute('name') || d.getAttribute('data-acc-name');
        if (g !== group) continue;
        if (d.hasAttribute('name')) {
          d.setAttribute('data-acc-name', g);
          d.removeAttribute('name');
        }
        if (d !== details) peers.push(d);
      }
    }

    var closing = isOpen(details);
    if (!closing) {
      for (var j = 0; j < peers.length; j++) {
        if (isOpen(peers[j])) run(peers[j], true);
      }
    }
    run(details, closing);
  });
})();

/* --------------------------------------------------------------------------
   SIZE TABLE UNITS: CM / INCH buttons. Cells carry data-cm; inches = cm / 2.54, one decimal,
   comma separator.
   Applies to every table on the page and is remembered for the visit (storage optional).
   Re-applied after a route swap.
   -------------------------------------------------------------------------- */
(function () {
  var KEY = 'ofiles-size-unit';

  /* Always one decimal so columns line up; 0 stays 0. */
  function fmt(n) {
    if (n === 0) return '0';
    return n.toFixed(1).replace('.', ',');
  }

  function apply(unit) {
    var tables = document.querySelectorAll('[data-size-table]');
    for (var t = 0; t < tables.length; t++) {
      var cells = tables[t].querySelectorAll('td[data-cm]');
      for (var i = 0; i < cells.length; i++) {
        var raw = cells[i].getAttribute('data-cm');
        var cm = parseFloat(raw);
        if (isNaN(cm) || !/^\s*-?\d+(\.\d+)?\s*$/.test(raw)) continue;
        cells[i].textContent = unit === 'in' ? fmt(cm / 2.54) : String(raw).replace('.', ',');
      }
      var btns = tables[t].querySelectorAll('[data-unit]');
      for (var b = 0; b < btns.length; b++) {
        btns[b].setAttribute('aria-pressed', btns[b].getAttribute('data-unit') === unit ? 'true' : 'false');
      }
    }
  }

  function stored() {
    try { return localStorage.getItem(KEY) === 'in' ? 'in' : 'cm'; } catch (e) { return 'cm'; }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-size-table] [data-unit]');
    if (!btn) return;
    var unit = btn.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
    try { localStorage.setItem(KEY, unit); } catch (err) {}
    apply(unit);
  });

  function init() { if (stored() === 'in') apply('in'); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('ofiles:swap', init);
})();

/* --------------------------------------------------------------------------
   SLIDER (sections/slider.liquid): native scroll-snap track. This adds the arrows (one view
   per press) and the counter.
   Step and view size are read from the layout, so it works at any width. Re-runs after a
   swap or editor re-render.
   -------------------------------------------------------------------------- */
(function () {
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function bind(s) {
    if (s._slider) return;
    var track = s.querySelector('[data-slider-track]');
    if (!track) return;
    s._slider = true;

    var prev = s.querySelector('[data-slider-prev]');
    var next = s.querySelector('[data-slider-next]');
    var from = s.querySelector('[data-slider-from]');
    var to = s.querySelector('[data-slider-to]');
    var range = s.querySelector('[data-slider-range]');
    var slides = track.children;

    function step() {
      if (slides.length < 2) return track.clientWidth || 1;
      return (slides[1].offsetLeft - slides[0].offsetLeft) || 1;
    }

    function perView() {
      var gap = step() - (slides[0] ? slides[0].offsetWidth : 0);
      return Math.max(1, Math.round((track.clientWidth + gap) / step()));
    }

    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; }

    function update() {
      var n = slides.length;
      if (!n) return;
      var pv = Math.min(perView(), n);
      var i = Math.round(track.scrollLeft / step());
      if (atEnd()) i = Math.max(0, n - pv);
      var last = Math.min(n, i + pv);
      if (from) from.textContent = pad(i + 1);
      if (to) to.textContent = pad(last);
      if (range) range.hidden = last === i + 1;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = atEnd();
    }

    /* A second press mid-glide counts from where the first was heading. */
    var goal = null;
    var settle = 0;

    function move(dir) {
      var max = track.scrollWidth - track.clientWidth;
      var base = goal !== null ? goal : track.scrollLeft;
      goal = Math.max(0, Math.min(max, base + dir * step() * perView()));
      track.scrollTo({
        left: goal,
        behavior: reduce && reduce.matches ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { move(-1); });
    if (next) next.addEventListener('click', function () { move(1); });

    var queued = false;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { goal = null; }, 150);
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var all = document.querySelectorAll('[data-slider]');
    for (var i = 0; i < all.length; i++) bind(all[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('ofiles:swap', init);
  document.addEventListener('shopify:section:load', init);
})();

/* --------------------------------------------------------------------------
   LONG TEXT CONTENTS (page-content.liquid, Layout: Automatic).
   Clicks smooth-scroll to the section and replaceState the #id. aria-current marks the
   section being read (last heading above a line 25% down; last entry at the foot).
   On a phone the sticky line scrolls the current entry into view. Headings take focus after
   a click.
   -------------------------------------------------------------------------- */
(function () {
  var reduce = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : null;
  var links = [];
  var heads = [];
  var current = null;
  var margin = 0;      /* the headings' scroll-margin-top: where a jump lands */
  var line = 0;        /* the reading line, px from the top of the screen */
  var queued = false;
  var holding = false; /* a clicked glide is running */
  var idle = 0;
  var cap = 0;

  function behaviour() { return reduce && reduce.matches ? 'auto' : 'smooth'; }

  function headFor(a) {
    var id = (a.getAttribute('href') || '').slice(1);
    try { id = decodeURIComponent(id); } catch (e) {}
    return id ? document.getElementById(id) : null;
  }

  function atBottom() {
    return window.scrollY > 0 &&
      window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2;
  }

  /* The phone's sideways line: bring the current entry in if it is cut off. */
  function reveal(a) {
    var ol = a.parentNode && a.parentNode.parentNode;
    if (!ol || ol.scrollWidth <= ol.clientWidth + 1) return;
    var pad = parseFloat(getComputedStyle(ol).paddingLeft) || 0;
    var box = ol.getBoundingClientRect();
    var r = a.getBoundingClientRect();
    if (r.left >= box.left + pad - 1 && r.right <= box.right - pad + 1) return;
    ol.scrollTo({ left: ol.scrollLeft + r.left - box.left - pad, behavior: behaviour() });
  }

  function mark(a) {
    if (a === current) return;
    if (current) current.removeAttribute('aria-current');
    current = a || null;
    if (!current) return;
    current.setAttribute('aria-current', 'true');
    reveal(current);
  }

  function measure() {
    margin = heads.length ? parseFloat(getComputedStyle(heads[0]).scrollMarginTop) || 0 : 0;
    line = margin + (window.innerHeight - margin) / 4;
  }

  function spy() {
    queued = false;
    if (!heads.length || holding) return;
    var i = 0;
    if (atBottom()) {
      i = heads.length - 1;
    } else {
      for (var k = 0; k < heads.length; k++) {
        if (heads[k].getBoundingClientRect().top <= line + 1) i = k;
        else break;
      }
    }
    mark(links[i]);
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(spy);
  }

  /* Glide stopped: keep the clicked entry if it arrived, otherwise re-read the page. */
  function release() {
    clearTimeout(idle);
    clearTimeout(cap);
    holding = false;
    var h = current && headFor(current);
    if (h && (Math.abs(h.getBoundingClientRect().top - margin) < 2 || atBottom())) return;
    queue();
  }

  window.addEventListener('scroll', function () {
    if (holding) {
      clearTimeout(idle);
      idle = setTimeout(release, 150);
      return;
    }
    if (heads.length) queue();
  }, { passive: true });

  window.addEventListener('resize', function () {
    if (!heads.length) return;
    measure();
    queue();
  });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('.info__toc a');
    if (!a || links.indexOf(a) === -1) return;
    var head = headFor(a);
    if (!head) return;
    e.preventDefault();

    holding = true;
    clearTimeout(idle);
    clearTimeout(cap);
    idle = setTimeout(release, 250);   /* re-armed by each scroll of the glide */
    cap = setTimeout(release, 2000);   /* in case a glide never reports */
    mark(a);

    head.scrollIntoView({ behavior: behaviour(), block: 'start' });
    try { history.replaceState(history.state, '', '#' + head.id); } catch (err) {}
    head.setAttribute('tabindex', '-1');
    head.focus({ preventScroll: true });
  });

  function init(e) {
    clearTimeout(idle);
    clearTimeout(cap);
    holding = false;
    current = null;
    links = [];
    heads = [];
    var toc = document.querySelector('.info__toc');
    if (!toc) return;
    var all = toc.querySelectorAll('a[href^="#"]');
    for (var i = 0; i < all.length; i++) {
      all[i].removeAttribute('aria-current');
      var h = headFor(all[i]);
      if (h) { links.push(all[i]); heads.push(h); }
    }
    if (!heads.length) return;
    measure();

    /* #section in the URL after a swapped navigation: scroll there (the swap layer scrolls
       to the top). */
    var hash = location.hash.slice(1);
    try { hash = decodeURIComponent(hash); } catch (err) {}
    for (var k = 0; hash && k < heads.length; k++) {
      if (heads[k].id !== hash) continue;
      if (!e || (e.type === 'ofiles:swap' && e.detail && e.detail.push)) {
        if (e) heads[k].scrollIntoView({ block: 'start' });
        mark(links[k]);
        return;
      }
    }
    spy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('ofiles:swap', init);
  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================================
   WITHDRAWAL (sections/withdrawal.liquid)
   On confirm: validate the required fields, add a reference and timestamp, send a Withdrawal
   Declared event to Klaviyo (6s timeout), then submit to Shopify as a contact form with the
   result in RECEIPT.
   After the redirect (?contact_posted=true) the received state reads its details from
   sessionStorage.
   App fallback: scripts inserted by the route swap never run, so they are re-created here
   after a swap.
   ========================================================================== */
(function () {
  var STASH = 'ofiles:withdrawal';
  var STALE = 30 * 60 * 1000;       /* a stash older than this is not shown */
  var TIMEOUT = 6000;
  var REVISION = '2026-07-15';

  function val(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function reference() {
    var t = Date.now().toString(36).toUpperCase().slice(-5);
    var r = Math.random().toString(36).toUpperCase().slice(2, 5);
    return 'W-' + t + r;
  }

  function stamp(d) {
    try {
      return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric', month: 'long', year: 'numeric',
        hour: '2-digit', minute: '2-digit', timeZoneName: 'short'
      }).format(d);
    } catch (err) {
      return d.toString();
    }
  }

  /* --- validation ------------------------------------------------------- */
  function errorFor(input) {
    var id = input.id + '-error';
    return document.getElementById(id);
  }

  function setError(input, text) {
    var p = errorFor(input);
    if (text) {
      input.setAttribute('aria-invalid', 'true');
      if (p) { p.textContent = text; p.hidden = false; }
    } else {
      input.removeAttribute('aria-invalid');
      if (p) { p.textContent = ''; p.hidden = true; }
    }
  }

  function check(input) {
    var v = input.value.trim();
    if (input.name === 'contact[name]') return v ? '' : 'Enter your name';
    if (input.name === 'contact[Order number]') return v ? '' : 'Enter your order number';
    if (input.name === 'contact[email]') {
      if (!v) return 'Enter your email address';
      if (input.validity && input.validity.typeMismatch) return 'Check the email address';
    }
    return '';
  }

  function validate(form) {
    var first = null;
    var req = form.querySelectorAll('[required]');
    for (var i = 0; i < req.length; i++) {
      var msg = check(req[i]);
      setError(req[i], msg);
      if (msg && !first) first = req[i];
    }
    return first;
  }

  /* --- Klaviyo ---------------------------------------------------------- */
  function send(key, metric, d) {
    if (!key || !window.fetch) return Promise.resolve(false);
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT);

    var body = {
      data: {
        type: 'event',
        attributes: {
          properties: {
            reference: d.reference,
            submitted_at: d.submitted_at,
            submitted_at_iso: d.submitted_at_iso,
            name: d.name,
            email: d.email,
            order_number: d.order_number,
            items: d.items || 'Whole order',
            notes: d.notes,
            page: d.page
          },
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: { email: d.email } } },
          time: d.submitted_at_iso,
          unique_id: d.reference
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      clearTimeout(timer);
      return res.status === 202 || res.ok;
    }).catch(function () {
      clearTimeout(timer);
      return false;
    });
  }

  /* --- the form ---------------------------------------------------------- */
  function bind(root) {
    var form = root.querySelector('form');
    if (!form || form.__withdraw) return;
    form.__withdraw = true;
    form.noValidate = true;

    var button = form.querySelector('[data-withdraw-submit]');
    var busy = false;
    var label = button ? button.textContent : '';

    /* Restored from the page cache: reset the SENDING state. */
    form.__withdrawReset = function () {
      busy = false;
      if (button) { button.disabled = false; button.textContent = label; }
    };

    /* A flagged field clears once valid; no messages while typing. */
    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.getAttribute && t.getAttribute('aria-invalid') === 'true' && !check(t)) setError(t, '');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;

      var bad = validate(form);
      if (bad) { bad.focus(); return; }

      busy = true;
      if (button) { button.disabled = true; button.textContent = 'Sending'; }

      var now = new Date();
      var d = {
        reference: reference(),
        submitted_at: stamp(now),
        submitted_at_iso: now.toISOString(),
        name: val(form, 'contact[name]'),
        email: val(form, 'contact[email]'),
        order_number: val(form, 'contact[Order number]'),
        items: val(form, 'contact[Items]'),
        notes: val(form, 'contact[body]'),
        page: location.origin + location.pathname
      };

      var ref = form.querySelector('[data-withdraw-ref]');
      var time = form.querySelector('[data-withdraw-time]');
      var receipt = form.querySelector('[data-withdraw-receipt]');
      if (ref) ref.value = d.reference;
      if (time) time.value = d.submitted_at + ' (' + d.submitted_at_iso + ')';

      send(root.getAttribute('data-klaviyo'), root.getAttribute('data-metric') || 'Withdrawal Declared', d)
        .then(function (ok) {
          d.receipt = ok;
          if (receipt) {
            receipt.value = ok
              ? 'Sent automatically by Klaviyo to ' + d.email + '.'
              : 'NOT SENT. Klaviyo did not answer, so no receipt went to the customer. Reply to ' +
                d.email + ' to confirm you have received it, quoting ' + d.reference + '.';
          }
          d.stashed = Date.now();
          try { sessionStorage.setItem(STASH, JSON.stringify(d)); } catch (err) {}
          /* Prototype submit: bypasses this handler and any field named submit. */
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  }

  /* --- received ----------------------------------------------------------- */
  function row(list, label, value) {
    var dt = document.createElement('dt');
    var dd = document.createElement('dd');
    dt.textContent = label;
    dd.textContent = value;
    list.appendChild(dt);
    list.appendChild(dd);
  }

  function received(root) {
    var done = root.querySelector('[data-withdraw-done]');
    if (!done) return;

    var d = null;
    try { d = JSON.parse(sessionStorage.getItem(STASH) || 'null'); } catch (err) {}
    try { sessionStorage.removeItem(STASH); } catch (err) {}

    if (d && d.stashed && Date.now() - d.stashed < STALE) {
      var msg = done.querySelector('[data-withdraw-message]');
      if (msg) {
        msg.textContent = d.receipt
          ? 'A receipt has been emailed to ' + d.email + '. Keep the reference for your return.'
          : 'We have received it and will email a receipt to ' + d.email + '. Keep the reference for your return.';
      }
      var list = done.querySelector('[data-withdraw-list]');
      if (list) {
        row(list, 'Reference', d.reference);
        row(list, 'Submitted', d.submitted_at);
        row(list, 'Name', d.name);
        row(list, 'Email', d.email);
        row(list, 'Order', d.order_number);
        row(list, 'Items', d.items || 'Whole order');
        if (d.notes) row(list, 'Notes', d.notes);
        list.hidden = false;
      }
    }
    done.focus({ preventScroll: true });
  }

  /* --- the app fallback after a swap -------------------------------------- */
  function rerunApp(root) {
    var app = root.querySelector('[data-withdraw-app]');
    if (!app) return;
    var old = app.querySelectorAll('script');
    for (var i = 0; i < old.length; i++) {
      var s = document.createElement('script');
      for (var a = 0; a < old[i].attributes.length; a++) {
        s.setAttribute(old[i].attributes[a].name, old[i].attributes[a].value);
      }
      s.text = old[i].text;
      old[i].parentNode.replaceChild(s, old[i]);
    }
  }

  function init(e) {
    var root = document.querySelector('[data-withdraw]');
    if (!root) return;
    bind(root);
    received(root);
    if (e && e.type === 'ofiles:swap') rerunApp(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('ofiles:swap', init);
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var form = document.querySelector('[data-withdraw] form');
    if (form && form.__withdrawReset) form.__withdrawReset();
  });
})();
